import { connect, MapStateToProps } from 'react-redux';
import { Props } from './Strips';
import { AppState } from '../../types/store';
import {
  getStrips,
  getCurrentPageType,
  getSearchQuery,
  getTopStrips,
  getMainContentUrl,
} from '../../selectors/page';

export type StateProps = Pick<
  Props,
  'strips' | 'mainContentUrl' | 'originalSearchTerm' | 'isSearchPage'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const { areTopStrips } = ownProps;
  return {
    strips: areTopStrips ? getTopStrips(state) : getStrips(state),
    mainContentUrl: getMainContentUrl(state),
    originalSearchTerm: getSearchQuery(state),
    isSearchPage: getCurrentPageType(state) === 'search',
  };
};

export default connect(mapStateToProps);
